<template>
    <div>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md6>
                    <v-card :height="screenHeight" scrollable>
                        <slot />
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'ScoreTemplate',
    data: () => ({
        
    }),
    computed: {
        screenHeight () {
            let scrHeigh = (screen.height - 125).toString()
            if(scrHeigh > 810){
                 scrHeigh = 810 
            } else if (scrHeigh < 300) {
                scrHeigh = 500
            }
            return scrHeigh
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/templates/ScoreTemplate.vue